import {useEffect, useRef, useState} from 'react'
import {Form,Input,App,Modal, Rate} from 'antd'
import { useTaskManageAddMutation } from '../../store/BnsKeJiApi';
import ModuleSelect from '../module/ModuleSelect';
import SubmoduleSelect from '../submodule/SubmoduleSelect';
import { PlusSquareOutlined } from '@ant-design/icons';
import { InterfaceGrade } from './InterfaceGrade';
const {TextArea} = Input
function InterfaceAdd(props) {
    const {message} = App.useApp();
    const [form] = Form.useForm();   
    const [submit] = useTaskManageAddMutation();
    const [info,setInfo] = useState({
        et_content: '',
        et_e_id: localStorage.getItem('e_id'),
        et_name: '',
        et_uid: localStorage.getItem('eu_id'),
        et_uname: localStorage.getItem('eu_name'),
        etu_user_id: localStorage.getItem('eu_id'),
        etu_user_name: localStorage.getItem('eu_name'),
        et_date:'1',
        et_status:'1',
        et_grade:'1',
        et_gs:'0',
        et_bg_id:'',
        et_bgn_id:''
    });
    const [open, setOpen] = useState(false);
    const editForm = useRef();
    useEffect(() => {
        setInfo(prevState => ({
            ...prevState,
            et_bg_id:props.bg_id,
            et_bg_name:props.bg_name,
            et_bgn_id:props.bgn_id,
            et_bgn_name:props.bgn_name,
            et_bbb_id:props.bbb_id,
            et_bbb_name:props.bbb_name,
        }));
        
        if (editForm.current) {
            editForm.current.setFieldsValue({
                et_bg_name: props.bg_name,
                et_bgn_name:props.bgn_name,
                et_bbb_name:props.bbb_name,
            });
        }
    }, [props.bg_id,props.bg_name,props.bbb_id,props.bbb_name,props.bgn_id,props.bgn_name,open]);
    return (
        <>
            <a onClick={() => {setOpen(true)}} style={{width:"100px"}}><PlusSquareOutlined /> 新增接口</a>
            <Modal
                open={open}
                width={800}
                title={props.bg_name + '- 新增接口'}
                onCancel={() => {setOpen(false)}}
                onOk={() => {
                    form.resetFields();  
                    submit(info).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {                            
                            message.success('新增成功！')  
                            setOpen(false)   
                        }
                        if (res.data.Status === 'fail') {
                            message.error('新增失败！'+res.data.Message)
                        }
                    })       
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}   
                    ref={editForm}
                >                                                       
                    <ModuleSelect
                        required
                        wrapperCol={{span:15}}
                        bgn_bg_id={props.bg_id}
                        bgn_bg_name={props.bg_name}
                        onChange={(e,f) => {
                            setInfo(prevState=>({...prevState,et_bgn_id:e,et_bgn_name:f.label}))
                        }}
                        name='et_bgn_name'
                        label='模块'
                        style={{width:"200px"}}
                    />
                    <SubmoduleSelect
                        required
                        wrapperCol={{span:15}}
                        bg_id={props.bg_id}
                        bg_name={props.bg_name}
                        bgn_id={info.et_bgn_id}
                        bgn_name={info.et_bgn_name}
                        onChange={(e,f) => {
                            setInfo(prevState=>({...prevState,et_bbb_id:e,et_bbb_name:f.label}))
                        }}
                        label='子模块'
                        name='et_bbb_name'
                        style={{width:"200px"}}
                    />                
                    <Form.Item name="name" label='接口名称' wrapperCol={{span:15}} required >                        
                        <Input  onChange={(e) => {setInfo(prevState=>({...prevState,et_name:e.target.value,}))}}/>
                    </Form.Item>                        
                    <Form.Item name="et_grade" label='优先级' wrapperCol={{span:15}} required >                        
                        <Rate  
                            onChange={(e) => {
                                setInfo(prevState=>({...prevState,et_grade:e}))}
                            }
                            character={({ index = 0 }) => InterfaceGrade[index + 1]}
                        />
                    </Form.Item>                            
                    <Form.Item name="et_content" label='接口说明' wrapperCol={{span:15}}>
                        <TextArea  onChange={(e) => {setInfo(prevState=>({...prevState,et_content:e.target.value,}))}}/>                   
                    </Form.Item>
                </Form>     
            </Modal>                  
        </>
    )
}

export default InterfaceAdd